/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Container for loading instructor/students tabs based on user role
 *
 * @file UserBaseTabContainer.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import UserRoleTab from '../components/tabs/UserRoleTab';

const UserBaseTabContainer = ({
  bulkDownloadStatus, handleTabChange, tabValue, showTeacherTab, showStudentTab
}) => (
  <div className="resource-tab-container">
    <UserRoleTab
      bulkDownloadStatus={bulkDownloadStatus}
      handleTabChange={handleTabChange}
      tabValue={tabValue}
      showTeacherTab={showTeacherTab}
      showStudentTab={showStudentTab}
    />
  </div>
);

UserBaseTabContainer.propTypes = {
  bulkDownloadStatus: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  tabValue: PropTypes.number.isRequired,
  showTeacherTab: PropTypes.bool.isRequired,
  showStudentTab: PropTypes.bool.isRequired
};

export default memo(UserBaseTabContainer);
